export function userArrayToBlob(users) {
    var csv = users.reduce(function (acc, user) {
        return "".concat(acc).concat(user.email, "\"\r\n");
    }, 'Email\r\n');
    return new Blob([csv], { type: 'text/csv' });
}
//# sourceMappingURL=utils.js.map